import { render, staticRenderFns } from "./LanguagePage.vue?vue&type=template&id=4aefc0a0&scoped=true&"
import script from "./LanguagePage.vue?vue&type=script&lang=ts&"
export * from "./LanguagePage.vue?vue&type=script&lang=ts&"
import style0 from "./LanguagePage.vue?vue&type=style&index=0&id=4aefc0a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aefc0a0",
  null
  
)

export default component.exports